import Card from "components/card";

const InfoCard = (props) => {
    const { label, icon, value, span } = props;
    return (
        <Card className={`rounded-xl border ${span}`}>
            <div className="px-6 pt-6 pb-6">
                <div className="flex items-start gap-3 w-full">
                    <div className="flex-shrink-0">
                        <div className="w-4 h-4 mt-0.5 flex items-center justify-center muted-text">
                            {icon}
                        </div>
                    </div>

                    <div className="flex flex-col">
                        <p className="text-[10px] uppercase tracking-wide leading-tight muted-text">
                            {label}
                        </p>
                        <p className="text-[14px] font-medium mt-1 leading-tight break-all title-text">
                            {value}
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default InfoCard;
